import { createContext } from 'react';

import { PermissionsContextValue } from '../permissionsContextController/PermissionsContext.types';

export const PermissionsContext = createContext<PermissionsContextValue | undefined>(undefined);
